console.log("PS gift box handler installed");

(function () {
 async function refreshCartDrawer() {
  const currentSection = document.querySelector('#shopify-section-cart-drawer');
  if (!currentSection) {
    console.warn('PS: #shopify-section-cart-drawer not found');
    return;
  }

  const url = '/?sections=cart-drawer&ts=' + Date.now();
  const res = await fetch(url, { credentials: 'same-origin' });
  if (!res.ok) {
    console.warn('PS: cart-drawer section fetch failed', res.status);
    return;
  }

  const json = await res.json();
  const html = json && json['cart-drawer'];
  if (!html) {
    console.warn('PS: cart-drawer HTML missing in response', json);
    return;
  }

  // Parse returned HTML and take ONLY the inside of #shopify-section-cart-drawer
  const doc = new DOMParser().parseFromString(html, 'text/html');
  const newSection = doc.querySelector('#shopify-section-cart-drawer');
  if (!newSection) {
    console.warn('PS: new #shopify-section-cart-drawer not found in fetched HTML');
    return;
  }

  // Swap inner content (avoids duplicate-id / theme state issues)
  currentSection.innerHTML = newSection.innerHTML;

  // Optional: if Minimog binds events to elements inside the drawer,
  // this keeps click handling stable without reopening the drawer.
}



  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('.js-ps-add-giftbox');
    if (!btn) return;


    const variantId = btn.getAttribute('data-variant-id');
    console.log("PS: adding gift box variant", variantId);



    if (!variantId) return;

    btn.disabled = true;

    try {
      const addRes = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ id: Number(variantId), quantity: 1 })
      });

      if (!addRes.ok) throw new Error('Add failed');
      document.querySelector('.ps-cart-upsell')?.remove();



      console.log("PS: refreshing cart drawer…");
      await refreshCartDrawer();

      // Verify the drawer shows the gift box; if not, force a safe refresh.
      setTimeout(() => {
        const drawerText =
          document.querySelector('#shopify-section-cart-drawer')?.innerText?.toLowerCase() || '';

        const hasGiftBox =
          drawerText.includes('premium magnetic gift box') ||
          drawerText.includes('premium-gift-box');

        if (!hasGiftBox) {
          console.warn('PS: drawer did not update visually — forcing page refresh');
          window.location.href = '/cart';

     }
   }, 350);
    



    } catch (err) {
      console.error(err);
      // fallback if AJAX is blocked
      window.location.href = '/cart';
    } finally {
      btn.disabled = false;
    }
  }, true);
})();
